

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Test_Landing_Card from "../Card/Test_Landing_Card";
import Button from "../Button/Button";
import { baseUrl } from "../../config";
import TestListPage from "../../pages/TestListPage";
import axios from 'axios';
import ExtensionAlert from "../Card/ExtensionAlert";
import SettingButton from "../Button/SettingButton";
import DateRange from "../Card/DateRange"
import {
  format,
  subMonths,
  
} from 'date-fns';

const Test_Landing = () => {
  const { websiteId } = useParams();
  const [website, setWebsite] = useState();
  const [isExtensionInstalled, setIsExtensionInstalled] = useState(false);
  const [showExtensionConfirm, setShowExtensionConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const [pdfLoader , setPdfLoader]= useState(false)
  const [showPop, setShowPopup] = useState(false);
  const now = new Date();
  const threeMonthsAgo = subMonths(now, 3);
  const [selectedRange, setSelectedRange] = useState({ start: null, end: null });
  const [leftMonth, setLeftMonth] = useState(subMonths(now, 1));
  const [rightMonth, setRightMonth] = useState(now);
  const [dateRange , setDateRange]= useState({startDate:"",endDate:""})

  // const handleDateClick = (date) => {
  //     if (date < threeMonthsAgo || date > now) return;

  //     if (!selectedRange.start || (selectedRange.start && selectedRange.end)) {
  //         setSelectedRange({ start: date, end: null });
  //     } else if (date < selectedRange.start) {
  //         setSelectedRange({ start: date, end: selectedRange.start });
  //     } else {
  //         setSelectedRange({ ...selectedRange, end: date });
  //     }
  // };

  const handleDateClick = (date) => {
    if (date < threeMonthsAgo || date > now) return;

    let newRange;

    if (!selectedRange.start || (selectedRange.start && selectedRange.end)) {
        newRange = { start: date, end: null };
    } else if (date < selectedRange.start) {
        newRange = { start: date, end: selectedRange.start };
    } else {
        newRange = { ...selectedRange, end: date };
    }

    setSelectedRange(newRange);

    // Format and log (or use as needed)
    const formattedStart = newRange.start ? format(newRange.start, 'yyyy-MM-dd') : null;
    const formattedEnd = newRange.end ? format(newRange.end, 'yyyy-MM-dd') : null;

    setDateRange({startDate:formattedStart , endDate:formattedEnd})
};


const generateReport = async () => {
  try {
    setPdfLoader(true)
    const response = await fetch(`${baseUrl}/report/${websiteId}/${dateRange.startDate}/${dateRange.endDate}`);

    if (!response.ok) {
      throw new Error('Failed to generate PDF');
      setPdfLoader(false)


    }

    console.log("reposne from pdffff", response)

    const blob = await response.blob();
    const pdfUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();

    // Clean up after 10 seconds
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 5000);
    setPdfLoader(false)
    // Open in new tab
    window.open(pdfUrl, '_blank');

   

  } catch (error) {
    console.error('Error:', error);
    setPdfLoader(false)
    alert('Failed to generate PDF: ' + error.message);
  }
}


  const handlePopup = (record) => {

    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const token = localStorage.getItem("Token")



  const fetchWebsiteByWebsiteId = async () => {
    try {
      setIsLoading(true)
      const response = await axios.get(`${baseUrl}/websites/${websiteId}`,

        {
          headers: { authorization: `Bearer ${token}` },
        }

      );
      console.log("response from website", response?.data);
      setWebsite(response?.data);
    } catch (error) {
      console.log("Error in fetching data", error.response);
    } finally {
      setIsLoading(false); // Stop loading once data is fetched
    }
  };

  useEffect(() => {
    fetchWebsiteByWebsiteId();
  }, [websiteId]);

  useEffect(() => {
    const handleLoad = () => {
      console.log("Page fully loaded");

      const hasShownConfirmation = localStorage.getItem("hasShownConfirmation");
      const messageListener = (event) => {
        if (event.source !== window) return;
        if (event.data.type === "EXTENSION_INSTALLED") {
          console.log("Extension is installed:", event.data.data);

          setIsExtensionInstalled(true);

          if (!hasShownConfirmation) {
            setShowExtensionConfirm(true);
          }
        }
      };

      // Add event listener for messages
      window.addEventListener("message", messageListener);

      // Send a message to check if the extension is installed
      console.log("Sending CHECK_EXTENSION message");
      window.postMessage({ type: "CHECK_EXTENSION" }, "*");

      // Clean up event listener on component unmount
      return () => {
        window.removeEventListener("message", messageListener);
      };
    };

    // Check if document is already loaded
    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);

      // Clean up the load event listener
      return () => {
        window.removeEventListener('load', handleLoad);
      };
    }
  }, []);

  const svg = <svg
    className="animate-spin h-12 w-12 mr-2 text-black"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 2.042.784 3.903 2.071 5.291l1.929-1.929z"
    ></path>
  </svg>
  return (
    <>
      {showPop && (
        <>
          <div className="fixed inset-0 bg-black opacity-50 z-40"></div>{" "}
          {/* Overlay */}
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <DateRange onClose={handleClosePopup} handleDateClick={handleDateClick} selectedRange={selectedRange}
            generateReport={generateReport} loader={pdfLoader}





            />
          </div>
        </>
      )}
      <div className="header-section">
        {!isExtensionInstalled && <ExtensionAlert />}
        <div className="info">
          <div className="flex flex-col gap-6">
            <div className="guide-info text-color-gray-light flex justify-between items-center">
              <h2 className='font-bold text-[24px]'>Tests</h2>
              <div className="flex flex-row gap-4 ">
                <SettingButton id={"generate_report"} text={"Generate Report"} bgColor='bg-white' loading={""} textColor="color-gray-light" hoverColor=''
                onClick={handlePopup}
                />
                <Button
                id={"create_new_test"}
                  text="Create New Test"
                  to={`/${websiteId}/test`}
                  disabled={!isExtensionInstalled}
                />

              </div>

            </div>


            {/* Reports */}


            {/* <div className="max-w-md mx-auto p-4 bg-white rounded-lg shadow">
              <h2 className="text-lg font-semibold mb-4">Select Date Range</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">Start Date</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    min={minDate}
                    max={endDate}
                    className="w-full p-2 border rounded"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">End Date</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    min={startDate}
                    max={today}
                    className="w-full p-2 border rounded"
                  />
                </div>
              </div>

              <div className="mt-4 p-3 bg-gray-50 rounded">
                <p className="text-sm">
                  Selected: {startDate} to {endDate}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  (Range limited to last 3 months from today)
                </p>
              </div>
            </div> */}





            {/* mt-5 remove */}
            <div className="setup-guide flex justify-between">
              <div className="inner-setup-guide flex flex-col gap-6 text-color-gray-light w-full">
                {isLoading ? (
                  // Skeleton loader during loading state
                  // <Skeleton height={150} count={1} />
                  // <div className=" relative flex justify-center items-center h-full top-32  ">
                  //div
                  <Test_Landing_Card svg={svg} />

                ) : (
                  // Render components based on condition after loading
                  website?.footprints?.length > 0 ? (
                    <TestListPage />
                  ) : (
                    <Test_Landing_Card
                      websiteId={websiteId}
                      isExtensionInstalled={isExtensionInstalled}
                    />
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Test_Landing;
